import { useGetMcpServersByAppIdQuery } from '../../../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpServerRegistryRpc.hooks';
import { McpServer } from '../../../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpServerRegistryRpc';

interface UseGetMcpServerOptions {
  appContext: string;
  isMcpServer?: boolean;
  sourceId?: number;
}

interface UseGetMcpServerResult {
  matchingMcpServer: McpServer | undefined;
  loading: boolean;
}

export function useGetMcpServer({
  appContext,
  isMcpServer,
  sourceId,
}: UseGetMcpServerOptions): UseGetMcpServerResult {
  const { data, loading } = useGetMcpServersByAppIdQuery({
    variables: { appId: sourceId ?? 0 },
    skip: !isMcpServer || appContext !== 'app' || !sourceId,
  });

  return {
    matchingMcpServer: data?.mcpServers?.[0],
    loading,
  };
}
